import Card from '../base/Card';
import Button from '../base/Button';

export default function Services() {
  const services = [
    {
      icon: 'ri-shield-check-line',
      title: 'Investigação Defensiva',
      description: 'Diferenciais que Tornam Nossa Investigação uma Aliada Estratégica da Defesa',
      painPoints: [
        'Suporte direto a advogados e escritórios de advocacia',
        'Estratégia integrada com a defesa técnica',
        'Atuação especializada em diferentes contextos jurídicos',
        'Diligências sigilosas e coleta técnica de provas',
        'Sigilo absoluto em todas as etapas',
        'Localização de pessoas, coleta de informações e registros estratégicos',
        'Relatórios conclusivos, detalhados e objetivos'
      ],
      image: 'https://readdy.ai/api/search-image?query=Corporate%20security%20investigation%20with%20documents%2C%20computer%20screens%20showing%20data%20analysis%2C%20professional%20investigator%20reviewing%20financial%20records%2C%20modern%20office%20environment%2C%20security%20shields%2C%20fraud%20detection%20tools%2C%20business%20protection%20concept&width=600&height=400&seq=defensive-investigation&orientation=landscape'
    },
    {
      icon: 'ri-user-search-line',
      title: 'Investigação de Funcionários',
      description: 'Background checks completos e investigações imparciais de conduta profissional.',
      painPoints: [
        'Assédio e desvios sem abordagem profissional',
        'Background checks incompletos gerando riscos',
        'Apropriação indébita não documentada',
        'Necessidade de investigações admissíveis legalmente'
      ],
      image: 'https://readdy.ai/api/search-image?query=Professional%20employee%20background%20check%20investigation%2C%20HR%20documents%2C%20personnel%20files%2C%20interview%20room%2C%20professional%20investigator%20with%20laptop%2C%20employee%20verification%20process%2C%20corporate%20HR%20environment%2C%20legal%20documentation&width=600&height=400&seq=employee-investigation&orientation=landscape'
    },
    {
      icon: 'ri-building-line',
      title: 'Investigação Patrimonial',
      description: 'Localização de ativos e verificação de antecedentes para processos legais.',
      painPoints: [
        'Ativos dispersos em separações/herança',
        'Verificação de parceiros comerciais/pessoais',
        'Fraudes patrimoniais e apropriação',
        'Comprovação para processos de divórcio/sucessão'
      ],
      image: 'https://readdy.ai/api/search-image?query=Asset%20investigation%20with%20property%20documents%2C%20real%20estate%20papers%2C%20financial%20records%2C%20legal%20documentation%2C%20professional%20investigator%20analyzing%20property%20ownership%2C%20wealth%20verification%2C%20inheritance%20documents%2C%20corporate%20assets&width=600&height=400&seq=asset-investigation&orientation=landscape'
    }
  ];

  const scrollToContact = () => {
    const element = document.getElementById('contato');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="servicos" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4">
            Serviços Especializados
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Três verticais principais para resolver os problemas mais complexos 
            da sua empresa com investigações profissionais e documentação legal adequada.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Card key={index} className="h-full flex flex-col" padding="lg">
              <div className="mb-6">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-48 object-cover object-top rounded-lg mb-4"
                />
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${service.icon} text-2xl text-teal-600`}></i>
                </div>
              </div>
              
              <h4 className="text-xl font-semibold text-gray-900 mb-3">
                <a href="#contato" className="hover:text-teal-600 transition-colors">
                  {service.title}
                </a>
              </h4>
              
              <p className="text-gray-600 mb-6 flex-grow">
                {service.description}
              </p>
              
              <div className="mb-6">
                <h5 className="font-medium text-gray-900 mb-3">Problemas que resolvemos:</h5>
                <ul className="space-y-2">
                  {service.painPoints.map((point, pointIndex) => (
                    <li key={pointIndex} className="flex items-start text-sm text-gray-600">
                      <i className="ri-check-line text-teal-600 mr-2 mt-0.5 flex-shrink-0"></i>
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
              
              <Button 
                variant="outline" 
                fullWidth 
                onClick={scrollToContact}
                className="mt-auto"
              >
                Solicitar Orçamento
              </Button>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
